import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ApiClient } from '../common/api-client.service';

interface Txn {
  fund_id: number;
  account_id: number
  amount: string;
  tag_list: string;
}

@Component({
  templateUrl: './enter.component.html'
})
export class TxnsEnterComponent implements OnInit {
  funds: Array<any> = [];
  accounts: Array<any> = [];
  txns: Txn[] = [];
  txnDate = new Date();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private apiClient: ApiClient
  ) {}

  ngOnInit() {
    this.apiClient.get<any>('/api/v1/ledger/details').toPromise().then(ledger => {
      this.funds = ledger.funds;
      this.accounts = ledger.accounts;

      if ( this.accounts.length === 1 ) {
        this.txns.forEach(txn => txn.account_id = this.accounts[0].id);
      }
    })

    const sheetId = this.route.snapshot.queryParams['sheet_id'];
    if ( sheetId ) {
      this.prefillFromSheet(sheetId);
    } else {
      this.add();
    }
  }

  total(): number {
    return this.txns.reduce((a, txn) => {
      return txn.amount && txn.amount !== '-' ? a + parseFloat(txn.amount) : a;
     }, 0);
  }

  add(): void {
    this.txns.push({fund_id: null, account_id: null, amount: null, tag_list: null});
  }

  remove(txn: Txn): void {
    this.txns.splice(this.txns.indexOf(txn), 1);
  }

  save(): void {
    const date = this.txnDate ? this.datePipe.transform(this.txnDate, 'yyyy-MM-dd') : null;
    const batch = this.txns.
      filter(t => t.account_id || t.fund_id || t.amount ).
      map(t => {
        return {amount: t.amount, fund_id: t.fund_id, account_id: t.account_id, date: date, tag_list: t.tag_list};
      });

    this.apiClient.post<Txn[]>('/api/v1/transactions/batch', {transactions: batch}).toPromise().then(txns => {
      // TODO success
      this.router.navigateByUrl('/')
    }, resp => {
      // TODO error
      alert(resp.error.errors);
    })
  }

  private prefillFromSheet(sheetId: string) {
    this.apiClient.get<any>(`/api/v1/sheets/${sheetId}`).toPromise().then(sheet => {
      sheet.transactions.forEach(t => {
        this.txns.push({fund_id: t.fund_id, account_id: t.account_id, amount: t.amount, tag_list: t.tags});
      })
    })
  }
}



// WEBPACK FOOTER //
// /srv/src/app/txns/enter.component.ts